import React from 'react';
import { Phone, ShieldAlert, CheckCircle2, Lock, ArrowRight, Star } from 'lucide-react';
function HeroStarRow() {
  return <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-893">
      {[0, 1, 2, 3, 4].map(i => <Star key={i} className="w-3.5 h-3.5 text-amber-500 fill-amber-500" data-id="element-894" />)}
    </span>;
}
export function HeroContent() {
  return <div className="lg:col-span-7 flex flex-col" data-id="element-895">
      <div className="inline-flex items-center gap-2 bg-emergencyBrand-redLight text-emergencyBrand-red px-4 py-2 rounded-full text-sm font-semibold mb-4 w-fit border border-emergencyBrand-redBorder" data-id="element-896">
        <span className="w-2 h-2 rounded-full bg-emergencyBrand-red" data-id="element-897" />
        <span data-id="element-898">Broken Windshield Today? Same-Day Openings May Be Available</span>
      </div>
      {/* Social proof bar */}
      <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-1.5 bg-white border border-slate-200 shadow-sm rounded-full px-4 py-2 mb-5 w-fit max-w-full" role="group" aria-label="Trust and social proof" data-id="element-899">
        <HeroStarRow data-id="element-900" />
        <span className="sr-only" data-id="element-901">5-star service.</span>
        <span className="text-xs sm:text-sm font-semibold text-slate-900" data-id="element-902">
          Drivers Across Southeast Michigan Trust Kosin's Glass
        </span>
        <span className="hidden sm:inline text-slate-300" aria-hidden="true" data-id="element-903">
          ·
        </span>
        <span className="text-xs sm:text-sm text-slate-600" data-id="element-904">
          Same-Day Openings May Be Available
        </span>
        <span className="hidden md:inline text-slate-300" aria-hidden="true" data-id="element-905">
          ·
        </span>
        <span className="hidden md:inline text-xs sm:text-sm text-slate-600" data-id="element-906">
          Family-Owned Since 2000
        </span>
      </div>
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 leading-[1.05] mb-6 tracking-tight" data-id="element-907">
        <span className="text-emergencyBrand-red" data-id="element-908">
          Emergency Auto Glass Repair
        </span>{' '}
        <span className="text-slate-900" data-id="element-909">&amp; Windshield Replacement in</span>{' '}
        <span className="text-emergencyBrand-red" data-id="element-910">Southeast Michigan</span>
      </h1>
      <p className="text-lg text-slate-600 mb-7 leading-relaxed max-w-2xl" data-id="element-911">
        Cracked windshield, shattered side window, broken rear glass or car door
        glass damage? Kosin's Glass provides urgent auto glass estimates,
        certified installation, insurance-claim help and same-day openings when
        available.
      </p>
      <ul className="space-y-3.5 mb-7" data-id="element-912">
        {['Windshield replacement, chip repair, side, door and rear window replacement', 'Same-day openings may be available depending on glass and schedule', 'Certified technicians using glass that meets or exceeds OEM standards', 'Insurance-claim help and lifetime vehicle glass workmanship warranty'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-913">
            <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-emergencyBrand-red flex items-center justify-center" data-id="element-914">
              <CheckCircle2 className="w-3 h-3 text-emergencyBrand-red" strokeWidth={3} data-id="element-915" />
            </span>
            <span className="text-slate-700" data-id="element-916">{bullet}</span>
          </li>)}
      </ul>
      <div className="flex flex-col sm:flex-row gap-3 mb-5" data-id="element-917">
        <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-918">
          <Phone className="w-5 h-5" data-id="element-919" />
          Call 517-545-7772 Now
        </a>
        <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-900 border border-slate-300 px-7 py-4 rounded-lg font-bold text-base transition-colors" data-id="element-920">
          Request Urgent Quote
          <ArrowRight className="w-4 h-4" data-id="element-921" />
        </a>
      </div>
      <p className="text-sm text-slate-500 mb-5" data-id="element-922">
        Serving Howell, Ann Arbor, Novi and Southeast Michigan.
      </p>
      <div className="bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 flex items-start gap-2.5 mb-3" data-id="element-923">
        <ShieldAlert className="w-4 h-4 text-slate-500 shrink-0 mt-0.5" data-id="element-924" />
        <p className="text-xs text-slate-600 leading-relaxed" data-id="element-925">
          If your visibility is blocked, glass is loose, or the vehicle feels
          unsafe to drive, do not continue driving. Call Kosin's Glass and the
          team will help you determine the safest next step.
        </p>
      </div>
      <div className="flex items-center gap-1.5 text-xs text-slate-500" data-id="element-926">
        <Lock className="w-3 h-3" data-id="element-927" />
        <span data-id="element-928">
          Your information is secure. Kosin's Glass will never share your
          details.
        </span>
      </div>
    </div>;
}